const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/payments-avaloq/api-factory');
const serviceFactory = require('../resources/payments-avaloq/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/payments/${apiConfig.apiversion}/`,
    authToken: config.authToken,
  });

  const service = serviceFactory({ api });

  const p = '[{keys:metaData}].';
  return app => app
      .match((`${p}payments.searchBankDetails[{keys:details}][{keys:guidStr}]`), requests =>
        Promise.all(requests.map(({ req, res }) =>
        service.getBankDetails(req.params.details, req.params.metaData)
          .then(xs => res.value(xs))


          .catch(res.error)
      )))
      
      .match(`${p}payments.searchCountry[{keys:country}][{keys:guidStr}]`, requests => 
        Promise.all(requests.map(({ req, res }) =>
        service.getCountryList(req.params.country, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))

      .match(`${p}payments.getBeneficiaryList[{keys:inputParam}][{keys:guidStr}]`, requests => 
        Promise.all(requests.map(({ req, res }) =>
        service.getBeneficiaryList(req.params.inputParam, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))

      .match(`${p}payments.getTemplateList[{keys:guidStr}]`, requests => 
        Promise.all(requests.map(({ req, res }) => (
          service.getTemplateList(req.params.metaData)
        )
          .then(xs=> (
            res.value(xs)))
          .catch( (res) => (  
            console.log("get template list error", res),
          res.error))
      )))
      
      .match(`${p}payments.filterListsLookup`, requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getFilterLists(req.params.metaData)
            .then(xs => res.value(xs))
            .catch(res.error)
        )))

      .match((`${p}payments.listTransactions[{keys:inputs}][{keys:guidStr}]`), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.listTransactions(req.params.inputs,req.params.metaData)
            .then(xs => res.value(xs))
            .catch(res.error)
      )))
      .match((`${p}payments.viewPaymentOrder[{keys:inputs}][{keys:guidStr}]`), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.viewPaymentOrder(req.params.inputs,req.params.metaData)
            .then(xs => res.value(xs))
            .catch(res.error)
      )))

      .match(`${p}payments.addNewBeneficiary[{keys:inputParam}][{keys:guidStr}]`, requests => 
        Promise.all(requests.map(({ req, res }) =>
          service.addBeneficiaryDetails(req.params.inputParam, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
    )))

    .match(`${p}payments.editBeneficiary[{keys:inputParam}][{keys:guidStr}]`, requests => 
        Promise.all(requests.map(({ req, res }) =>
          service.editBeneficiaryDetails(req.params.inputParam, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
)))

    .match(`${p}payments.deleteBeneficiary[{keys:inputParam}][{keys:guidStr}]`, requests => 
    Promise.all(requests.map(({ req, res }) =>
      service.deleteBeneficiary(req.params.inputParam, req.params.metaData)
      .then(xs => res.value(xs))
      .catch(res.error)
    )))

    .match(`${p}payments.deleteTemplate[{keys:inputParam}][{keys:guidStr}]`, requests => 
    Promise.all(requests.map(({ req, res }) =>
      service.deleteTemplate(req.params.inputParam, req.params.metaData)
      .then(xs => res.value(xs))
      .catch(res.error)
    )))

    .match(`${p}payments.saveUpdateTemplate[{keys:inputParam}][{keys:guidStr}]`, requests => 
    Promise.all(requests.map(({ req, res }) =>
      service.saveUpdateTemplate(req.params.inputParam, req.params.metaData)
      .then(xs => res.value(xs))
      .catch(res.error)
    )))

    .match((`${p}payments.getStandingOrderList[{keys:inputs}][{keys:guidStr}]`), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.getStandingOrderList(req.params.inputs,req.params.metaData)
            .then(xs => res.value(xs))
            .catch(res.error)
      )))

}

module.exports = addRoutes;
